import { Breadcrumbs, Typography, Stack, TablePagination, Link } from "@mui/material";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { useMemo } from "react";
import { GenerateProjetoRevisaoColumnDefinition } from "./columns";
import { useRevisaoListaSolicitarViewModel } from "../../viewModels/revisao_listasolicitar_view_model";

export const Revisao_listasolicitar = () => {
  const viewModel = useRevisaoListaSolicitarViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoRevisaoColumnDefinition({
      onActionEditar: viewModel.handleVisualizar,
    });
  }, [
    viewModel.handleVisualizar,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={viewModel.handleCreate}
              >
                Novo Item
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Typography className="text-primary-green">Solicitação de Revisão</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Solicitações de Revisão</h1>
          <RefreshButton onClick={() => viewModel.handleClear()} />
        </div>

        <Header
          ddlCentroCusto={viewModel.ddlCentroCusto}
          ddlProjeto={viewModel.ddlProjeto}
          ddlSolicitante={viewModel.ddlFuncionario}
          idsCentroCusto={viewModel.filters.idsCentroCusto}
          idsProjeto={viewModel.filters.idsProjeto}
          idsSolicitante={viewModel.filters.idsSolicitante}
          statusOptions={viewModel.ddlStatus}
          status={viewModel.filters.status ?? undefined}
          dataDe={viewModel.filters.dataDe}
          dataAte={viewModel.filters.dataAte}
          onCentroCustoChange={viewModel.handleCentroCustoChange}
          onProjetoChange={viewModel.handleProjetoChange}
          onSolicitanteChange={viewModel.handleSolicitanteChange}
          onStatusChange={viewModel.handleStatusChange}
          onDataChange={viewModel.handleDataChange}
          onClearFilters={viewModel.handleClear}
        />

        <Stack spacing={0}>
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

          <StyledDataGrid
            tableName="ProjetoRevisao"
            disableColumnMenu={false}
            showToolbar
            disableRowSelectionOnClick
            getRowId={(row: any) => row.idProjetoRevisao}
            columns={columnsDefinition}
            loading={viewModel.loading}
            rows={viewModel.listaRevisao ?? []}
            rowCount={viewModel.pagination.totalItems}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page - 1,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ['idProjetoRevisao'],
            }}
            getRowHeight={() => 'auto'}
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

        </Stack>
      </div>
    </>
  );
};
